import { useState, useEffect } from 'react';
import { Typography, Box, IconButton, Tooltip } from '@mui/material';
import { ImagePaths } from '../../Utility/ImagePaths';
import ToastMsg from '../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import { DataGrid } from '@mui/x-data-grid';
import { ConfirmPopup, CommonPatientDetails, CommonGridToolBarWithFilterText }
    from '../../Components/Common Components/CommonComponents';
import { useHistory } from "react-router-dom";

const OpToIpPopup = ({ countList, onClkClose }) => {
    const [state, setState] = useState({
        opRequestList: [],
        selectedPatient: {},
        isDeleteClk: false,
        isLoader: false,
        page: 0,
        pageSize: 10,
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: ''
    })

    const history = useHistory();

    useEffect(() => {
        getOPRequestList()
    }, [])

    const loaderFunction = (key) => {
        setState((prevState) => ({
            ...prevState,
            isLoader: key
        }))
    }

    const errorMsgFunc = (message) => {
        setState((prevState) => ({
            ...prevState,
            isErrorMsg: true,
            isErrorMsgText: message
        }))
    }

    const successMsgFunc = (message) => {
        setState((prevState) => ({
            ...prevState,
            successMsg: true,
            successMsgText: message
        }))
    }

    const msgClose = () => {
        setState((prevState) => ({
            ...prevState,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        }))
    }

    const getOPRequestList = () => {
        try {
            loaderFunction(true)
            RestAPIService.getAll(Serviceurls.OP_TO_IP_MOVE)
                .then(response => {
                    if (response.data.status == "success") {
                        loaderFunction(false)
                        setState((prevState) => ({
                            ...prevState,
                            opRequestList: response?.data?.data || []
                        }))
                        countList(true)
                    }
                })
                .catch(e => {
                    loaderFunction(false)
                    errorMsgFunc(e?.reponse?.data.message || e.message)
                })
        }
        catch (e) {
            errorMsgFunc(e.message)
        }
    }

    const onDeleteHandler = (data) => {
        setState((prevState) => ({
            ...prevState,
            isDeleteClk: true,
            selectedPatient: data
        }))
    }

    const closemoveIp = () => {
        setState((prevState) => ({
            ...prevState,
            isDeleteClk: false,
            selectedPatient: {}
        }))
    }

    const confirmSaveOpToIp = () => {
        try {
            let data = {
                appointment_id: state.selectedPatient?.appointment_id,
                ip_request_status: "rejected",
                ip_request_id: state.selectedPatient?.id
            }
            RestAPIService.updateWithOutId(data, Serviceurls.OP_TO_IP_MOVE)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        getOPRequestList()  // Refresh the list after successful deletion   
                        successMsgFunc(response.data.message)
                        closemoveIp()
                    }
                }).catch((error) => {
                    errorMsgFunc(error?.response?.data?.message || error.message)
                    closemoveIp()
                })
        } catch (error) {
            errorMsgFunc(error.message)
            closemoveIp()
        }
    }

    const gridToolBar = () => {
        return (<Box><CommonGridToolBarWithFilterText noExport={true} /></Box>)
    }

    const columns = [
        {
            field: 'patient_name', headerName: 'Patient Details', flex: 0.3,
            renderCell: ({ row }) => {
                return (<CommonPatientDetails data={row} fromOp={true} />)
            }, density: 'compact'
        },
        {
            field: 'consultant_name', headerName: 'Consultant', flex: 0.2,
            renderCell: ({ row }) => {
                let doctorName = row?.consultant_name
                let doctorSpec = row?.specialization_name
                return (
                    <Box>
                        {doctorName ? doctorName?.length > 30 ?
                            <Tooltip placement='top' title={doctorName}><Typography fontSize={'0.9vw'} fontWeight={600}>{doctorName?.slice(0, 28) + '...'}</Typography></Tooltip> :
                            <Typography fontSize={'0.9vw'} fontWeight={600}>{doctorName}</Typography> : '-'}
                        {doctorSpec ? doctorSpec?.length > 30 ?
                            <Tooltip placement='top' title={doctorSpec}><Typography fontSize={'0.8vw'}>{doctorSpec?.slice(0, 28) + '...'}</Typography></Tooltip> :
                            <Typography fontSize={'0.8vw'} >{doctorSpec}</Typography> : '-'}
                    </Box>
                )
            }
        },
        {
            field: 'action', headerName: 'Action', flex: 0.1, headerAlign: 'center', align: 'center',
            renderCell: ({ row }) => {
                return (
                    <Box sx={{ fontSize: '0.9vw', fontWeight: 600, display: 'flex' }}>
                        <IconButton
                            onClick={() => {
                                history.push({ pathname: "/IPHome/CreateAppointment", state: { fromOpRequest: true, patient_id: row?.patient_id, appointment_id: row?.appointment_id, ip_request_id: row?.id, consultant_id: row?.consultant_id, recommendation_id: row?.recommendation_id } })
                                onClkClose(false)
                            }}
                        >
                            <Box component={'img'} src={ImagePaths.CreateBill.default} height={'1.5dvw'} width={'1.8dvw'} />
                        </IconButton>
                        <IconButton
                            onClick={() => { onDeleteHandler(row) }}
                        >
                            <Box component={'img'} src={ImagePaths.Delete.default} height={'1.5dvw'} width={'1.8dvw'} />
                        </IconButton>
                    </Box>
                )
            }
        },
    ]

    return (
        <Box sx={{ margin: "0.5vw" }}>
            <Box width={"100%"} height={"2.5vw"}  display="flex" justifyContent={"space-between"} alignItems={"center"}>
                <Typography fontWeight={600} fontSize={"1vw"}>IP Request</Typography>
                <IconButton onClick={() => onClkClose()}>
                    <img
                        src={ImagePaths.LabCloseButton.default}
                        style={{ cursor: "pointer", height: "1vw", width: "1vw" }}
                        alt=""
                    />
                </IconButton>
            </Box>
            <Box component={'div'} width={"100%"} height={'25dvw'} mt={'0.5rem'}>
                <DataGrid
                    rows={state.opRequestList || []}
                    page={state.page}
                    columns={columns}
                    getRowId={(row) => row?.appointment_id || row?.id}
                    pageSize={state.pageSize}
                    onPageChange={(page) => { setState((prevState) => ({ ...prevState, page: page })) }}
                    onPageSizeChange={(pageSize) => { setState((prevState) => ({ ...prevState, pageSize: pageSize })) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    loading={state.isLoader}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {("No Records To Be Shown")}
                            </Box>
                        )
                    }}
                    headerHeight={40}
                />
            </Box>
            {
                state.isDeleteClk && <ConfirmPopup
                    cnfTitle={'Confirmation'}
                    cnfContent1={'Are you want to cancel this Ip Request?'}
                    cnfAlertPopupClose={closemoveIp.bind(this)}
                    cnfData={confirmSaveOpToIp.bind(this)}
                />
            }
            {state.isErrorMsg && <ToastMsg severity={"error"} msg={state.isErrorMsgText} msgPop={msgClose.bind(this)} />}
            {state.successMsg && <ToastMsg severity={"success"} msg={state.successMsgText} msgPop={msgClose.bind(this)} />}
        </Box>
    )
}

export default OpToIpPopup